<template>
	<div
		:class="{
			'cand-dashboard-maincontainer overflow-hidden': isLaptop,
			'height-100dvh': !isLaptop,
			'cand-dashboard-maincontainer-loggedout': !hasAccess() && isLaptop,
		}"
	>
		<div
			v-if="isLaptop && hasAccess()"
			class="cand-header d-flex align-items-center justify-content-between"
		>
			<div>Assessment</div>
			<div>
				<b-button class="candash-addBtn" @click="goToallAssessmentProgress()"
					>View All Assessment</b-button
				>
			</div>
		</div>
		<template v-else-if="hasAccess()">
			<NcdTopContainer />
		</template>
		<div
			v-if="!isLaptop && hasAccess()"
			class="viewall-asmnt-card d-flex align-items-center justify-content-between"
			id="hideinlaptop"
			@click="goToallAssessmentProgress()"
		>
			<div class="fam-mont fw-M fs-13 text-white">View All Assessments</div>
			<img
				src="../../assets/assessment/whitecirarw.svg"
				alt=""
				@click="goToallAssessmentProgress()"
			/>
		</div>
		<div
			:class="
				!isLaptop && !hasAccess()
					? 'top80px mob-back-body overflow-auto mob-loggedout-body'
					: isLaptop
					? `${hasAccess() ? 'mt-2' : ''} d-flex max-1825 `
					: 'mob-back-body overflow-auto mob-assess-body'
			"
		>
			<div
				:class="{
					'width-75 pr-16px invisible-scroll outerscroll-asmntcard': isLaptop,
					'outerscroll-asmntcard invisible-scroll': showAsmnttopcard,
					'outerscroll-asmntcard-loggedout': !hasAccess(),
				}"
			>
				<div
					class="your-asmnt-container pt-3 pb-0 mb-16px"
					v-if="showAsmnttopcard || loadingUserAssessments"
				>
					<div class="d-flex w-100 align-items-center px-3">
						<div
							class="position-relative"
							:class="{
								'mob-w-100 mr-0': !isLaptop,
								'w-80 mr-4': isLaptop,
							}"
						>
							<img
								class="lap-resumes-search-image-position"
								src="../../assets/headerSearch.svg"
								alt=""
							/>
							<b-form-input
								class="resumes-search-input"
								placeholder="Search Assessments"
								type="search"
								clearable
								v-model="tempSearchQuery"
								@keyup.enter="handleSearch"
							>
							</b-form-input>
						</div>

						<b-button
							class="candash-addBtn px-4"
							@click="handleSearch"
							id="hideinmobile"
							>Search</b-button
						>
					</div>
					<div
						class="d-flex align-items-center justify-content-between px-3 mt-20px"
					>
						<div class="text-black fs-16 fw-LM fam-lato">Your Assessment</div>
						<div
							class="fs-13 fw-M fam-mont text-blue d-flex align-items-center pointer"
							id="hideinmobile"
							@click="goToTabAssessment()"
						>
							View All
							<img
								src="../../assets/newdesign/assessPro/blueRightArrow.svg"
								alt=""
							/>
						</div>
					</div>
					<hr style="border-top: 1px solid #8c8c8c" class="mb-1" />
					<div
						class="d-flex mob-content-between"
						style="border-bottom: 1px solid #dddddd"
					>
						<div
							:class="
								activeAssessmentTab === 'completed'
									? 'asp-sel-tab'
									: 'asp-unsel-tab'
							"
							@click="activeAssessmentTab = 'completed'"
						>
							<span>Completed </span>
							<div
								v-if="activeAssessmentTab === 'completed'"
								class="asp-sel-line"
								style="left: 10px; width: 95%"
							></div>
						</div>
						<div
							:class="
								activeAssessmentTab === 'upcoming'
									? 'asp-sel-tab'
									: 'asp-unsel-tab'
							"
							@click="activeAssessmentTab = 'upcoming'"
						>
							<span>Upcoming </span>
							<div
								v-if="activeAssessmentTab === 'upcoming'"
								class="asp-sel-line"
							></div>
						</div>
						<div
							:class="
								activeAssessmentTab === 'ongoing'
									? 'asp-sel-tab'
									: 'asp-unsel-tab'
							"
							@click="activeAssessmentTab = 'ongoing'"
						>
							<div>Ongoing</div>
							<div
								v-if="activeAssessmentTab === 'ongoing'"
								class="asp-sel-line"
							></div>
						</div>
					</div>
					<!-- Completed Assessments Slider -->
					<div
						class="px-3 mt-20px pb-1px"
						v-if="activeAssessmentTab === 'completed'"
						:class="{ 'pb-3': !isScrollable('completedasmntscroll') }"
					>
						<template v-if="loadingUserAssessments">
							<div class="d-flex gap-3 ques-hor-scroll w-100 pb-2 mt-2">
								<AssessmentCardSkeleton
									v-for="i in 2"
									:key="i"
									customClass="assesspro-cards p-3"
								/>
							</div>
						</template>

						<template
							v-else-if="completedAssessments && completedAssessments.length"
						>
							<div
								class="position-relative"
								@mouseenter="hoveredSlider = 'completedasmntscroll'"
								@mouseleave="hoveredSlider = null"
							>
								<!-- LEFT -->
								<img
									v-show="
										hoveredSlider === 'completedasmntscroll' &&
										scrollStates.completedasmntscroll?.left
									"
									class="position-absolute pointer left-arrow"
									src="../../assets/newdesign/jobsearch/carouselLeft.svg"
									@click="scrollLeft('completedasmntscroll')"
								/>

								<!-- SCROLL -->
								<div
									class="d-flex gap-3 ques-hor-scroll w-100"
									ref="completedasmntscroll"
									@scroll="updateScrollState('completedasmntscroll')"
								>
									<AssessmentCard
										v-for="assessment in completedAssessments"
										:key="assessment.assessmentID"
										:assessment="assessment"
										cardType="completed"
										:attemptedTag="true"
									/>
								</div>

								<!-- RIGHT -->
								<img
									v-show="
										hoveredSlider === 'completedasmntscroll' &&
										scrollStates.completedasmntscroll?.right
									"
									class="position-absolute pointer right-arrow"
									src="../../assets/newdesign/jobsearch/carouselRight.svg"
									@click="scrollRight('completedasmntscroll')"
								/>
							</div>

							<HorizontalSliderBlog
								v-if="isScrollable('completedasmntscroll')"
								:scrollContainerRef="$refs.completedasmntscroll"
								scrollContainerId="completedasmntscrollContainer"
								class="mt-16px mb-16px"
							/>
						</template>
						<div
							v-else
							class="h-100 d-flex flex-column align-items-center justify-content-center"
						>
							<img
								class="nodata-hw"
								src="../../assets/newdesign/assessPro/noassessment.svg"
								alt=""
							/>
							<span class="uploadDocs-caution-font text-center mt-3 mob-fs-12"
								>Currently, there are no completed <br />tests</span
							>
						</div>
					</div>
					<!-- Upcoming Assessments Slider -->
					<div
						class="px-3 pb-1px mt-20px"
						v-if="activeAssessmentTab === 'upcoming'"
						:class="{ 'pb-3': !isScrollable('upcomingasmntscroll') }"
					>
						<template v-if="upcomingAssessments && upcomingAssessments.length">
							<div
								class="position-relative"
								@mouseenter="hoveredSlider = 'upcomingasmntscroll'"
								@mouseleave="hoveredSlider = null"
							>
								<!-- LEFT -->
								<img
									v-show="
										hoveredSlider === 'upcomingasmntscroll' &&
										scrollStates.upcomingasmntscroll?.left
									"
									class="position-absolute pointer left-arrow"
									src="../../assets/newdesign/jobsearch/carouselLeft.svg"
									@click="scrollLeft('upcomingasmntscroll')"
								/>

								<!-- SCROLL -->
								<div
									class="d-flex gap-3 ques-hor-scroll w-100"
									ref="upcomingasmntscroll"
									@scroll="updateScrollState('upcomingasmntscroll')"
								>
									<AssessmentCard
										v-for="assessment in upcomingAssessments"
										:key="assessment.assessmentID"
										:assessment="assessment"
										cardType="upcoming"
										:attemptedTag="true"
									/>
								</div>

								<!-- RIGHT -->
								<img
									v-show="
										hoveredSlider === 'upcomingasmntscroll' &&
										scrollStates.upcomingasmntscroll?.right
									"
									class="position-absolute pointer right-arrow"
									src="../../assets/newdesign/jobsearch/carouselRight.svg"
									@click="scrollRight('upcomingasmntscroll')"
								/>
							</div>

							<HorizontalSliderBlog
								v-if="isScrollable('upcomingasmntscroll')"
								:scrollContainerRef="$refs.upcomingasmntscroll"
								scrollContainerId="upcomingasmntscrollContainer"
								class="mt-16px mb-16px"
							/>
						</template>
						<div
							v-else
							class="h-100 d-flex flex-column align-items-center justify-content-center"
						>
							<img
								class="nodata-hw"
								src="../../assets/newdesign/assessPro/noassessment.svg"
								alt=""
							/>
							<span class="uploadDocs-caution-font text-center mt-3 mob-fs-12"
								>Currently, there are no upcoming <br />tests</span
							>
						</div>
					</div>
					<!-- Ongoing Assessments Slider -->
					<div class="px-3 pb-2 mt-2" v-if="activeAssessmentTab === 'ongoing'">
						<template v-if="ongoingAssessments && ongoingAssessments.length">
							<div
								class="d-flex gap-3 ques-hor-scroll w-100"
								ref="ongoingasmntscroll"
							>
								<AssessmentCard
									v-for="assessment in ongoingAssessments"
									:key="assessment.assessmentID"
									:assessment="assessment"
									cardType="ongoing"
									:attemptedTag="true"
								/>
							</div>
							<HorizontalSliderBlog
								v-if="isScrollable('ongoingasmntscroll')"
								:scrollContainerRef="$refs.ongoingasmntscroll"
								scrollContainerId="ongoingasmntscrollContainer"
								class="mt-16px mb-16px"
							/>
						</template>
						<div
							v-else
							class="h-100 d-flex flex-column align-items-center justify-content-center"
						>
							<img
								class="nodata-hw"
								src="../../assets/newdesign/assessPro/noassessment.svg"
								alt=""
							/>
							<span class="uploadDocs-caution-font text-center mt-3 mob-fs-12"
								>Currently, there are no ongoing <br />tests</span
							>
						</div>
					</div>
					<div
						class="view-more-mob-btn fs-13 fw-B fam-mont text-blue d-flex align-items-center justify-content-center"
						id="hideinlaptop"
						@click="goToTabAssessment()"
					>
						View All<img
							src="../../assets/newdesign/assessPro/blueRightArrow.svg"
							alt=""
						/>
					</div>
				</div>
				<div
					:class="{
						'asp-left-container': isLaptop,
						'overflow-hidden h-auto': showAsmnttopcard,
						'h-maxcontent asp-left-container': isLaptop && !showAsmnttopcard,
					}"
					:style="
						isPageLoading && isLaptop && hasAccess()
							? { height: 'calc(100vh - 148px)' }
							: {}
					"
				>
					<div class="asmnt-mobile-whitecards">
						<div class="asmnt-top-search-cards mob-padding-12 pb-0" style="">
							<div
								v-if="isLaptop"
								class="d-flex align-items-center justify-content-between mb-black-bold py-2 px-3"
							>
								<div
									class="d-flex w-100 align-items-center mt-3"
									v-if="!showAsmnttopcard && hasAccess()"
								>
									<div
										class="position-relative w-80 mr-4"
										:class="{
											'mob-w-100': !isLaptop,
										}"
									>
										<img
											class="lap-resumes-search-image-position"
											src="../../assets/headerSearch.svg"
											alt=""
										/>
										<b-form-input
											class="resumes-search-input"
											placeholder="Search Assessments"
											type="search"
											clearable
											v-model="tempSearchQuery"
											@keyup.enter="handleSearch"
										>
										</b-form-input>
									</div>

									<b-button
										class="candash-addBtn px-4"
										@click="handleSearch"
										id="hideinmobile"
										>Search</b-button
									>
								</div>
							</div>
							<div v-else class="d-flex flex-column gap-2">
								<div class="mb-header-txt d-flex" id="hideinmobile">
									Assessment Progress
								</div>
								<div
									class="mob-search-filter position-relative"
									v-if="!showAsmnttopcard && hasAccess()"
								>
									<b-form-input
										placeholder="Search Assessments"
										type="search"
										clearable
										v-model="tempSearchQuery"
										@keyup.enter="handleSearch"
									></b-form-input>
									<img
										class="mob-search-pos"
										src="../../assets/mobile/assprog/search.svg"
										alt=""
									/>
								</div>
								<div class="cat-heading" id="hideinmobile">All Categories</div>
							</div>
							<section class="px-3 mob-px-0 position-relative">
								<div
									class="d-flex align-items-baseline justify-content-between"
								>
									<div
										v-if="
											recommendationAssessments &&
											recommendationAssessments.length
										"
										class="fw-M fs-16 fam-mont text-darkgrey mb-16px mob-fs-14 mt-1 mobw-70"
									>
										{{
											hasAccess()
												? "Recommendations based on your profile"
												: "Upskill your skills"
										}}
										<div
											v-if="!hasAccess()"
											class="fw-LM fs-14 fam-mont text-lightgrey mb-2 mob-fs-12"
										>
											Validate your skills with industry-standard assessments
										</div>
									</div>
									<div
										v-if="!hasAccess()"
										class="fs-13 fw-M fam-mont text-blue d-flex align-items-center pointer"
										@click="goToallAssessmentProgress()"
									>
										View All
										<img
											src="../../assets/newdesign/assessPro/blueRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<template v-if="loadingRecommendations">
									<div class="d-flex gap-3 ques-hor-scroll w-100 pb-2 mt-2">
										<AssessmentCardSkeleton
											v-for="i in 2"
											:key="i"
											:isMobile="!isLaptop"
											customClass="assesspro-cards p-3"
										/>
									</div>
								</template>
								<template
									v-if="
										recommendationAssessments &&
										recommendationAssessments.length
									"
								>
									<div
										class="recommendation-wrapper position-relative"
										@mouseenter="hoveredSlider = 'recomendationscroll'"
										@mouseleave="hoveredSlider = null"
									>
										<img
											v-show="
												hoveredSlider === 'recomendationscroll' &&
												scrollStates.recomendationscroll?.left
											"
											class="position-absolute pointer left-arrow"
											src="../../assets/newdesign/jobsearch/carouselLeft.svg"
											@click="scrollLeft('recomendationscroll')"
										/>

										<div
											class="d-flex gap-3 ques-hor-scroll w-100"
											ref="recomendationscroll"
											@scroll="updateScrollState('recomendationscroll')"
										>
											<AssessmentCard
												v-for="assessment in recommendationAssessments"
												:key="assessment.assessmentID"
												:assessment="assessment"
												:attemptedTag="true"
											/>
										</div>

										<img
											v-show="
												hoveredSlider === 'recomendationscroll' &&
												scrollStates.recomendationscroll?.right
											"
											class="position-absolute pointer right-arrow"
											src="../../assets/newdesign/jobsearch/carouselRight.svg"
											@click="scrollRight('recomendationscroll')"
										/>
									</div>

									<HorizontalSliderBlog
										v-if="isScrollable('recomendationscroll')"
										:scrollContainerRef="$refs.recomendationscroll"
										scrollContainerId="recomendationscroll3"
										class="mt-2"
									/>
								</template>
							</section>
							<div
								v-if="
									recommendationAssessments && recommendationAssessments.length
								"
								class="dashed-divider"
								:class="{
									'mt-3': !isScrollable('recomendationscroll'),
								}"
								id="hideinmobile"
							></div>
						</div>
						<div class="dashed-divider" id="hideinlaptop"></div>
						<section
							class="px-3 mt-3"
							:class="{
								'mb-3':
									!projectAssessment &&
									!projectAssessment.length &&
									!leaderboardAssessments &&
									!leaderboardAssessments.length,
							}"
						>
							<div class="fw-M fs-16 fam-mont text-darkgrey mb-2 mob-fs-14">
								Explore By Category
							</div>

							<div class="category-grid">
								<template v-if="loadingCategories">
									<b-skeleton
										v-for="i in 6"
										:key="i"
										width="168px"
										height="75px"
									/>
								</template>
								<template v-else>
									<AssessmentCategories
										v-for="category in categories"
										:key="category.categoryID"
										:category="category"
										@select="handleCategorySelect"
									/>
								</template>
							</div>
						</section>
						<div
							class="dashed-divider my-3"
							v-if="projectAssessment && projectAssessment.length"
						></div>

						<section
							class="px-3 mt-2"
							v-if="projectAssessment && projectAssessment.length"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<div class="fw-M fs-16 fam-mont text-darkgrey mb-1 mob-fs-14">
										Projects
									</div>
									<div
										class="fw-LM fs-14 fam-mont text-lightgrey mb-2 mob-fs-12"
									>
										Practice from real world coding challenges
									</div>
								</div>
								<div
									class="fs-13 fw-M fam-mont text-blue d-flex align-items-center pointer"
									id="hideinmobile"
									@click="goToFilteredAssessment('sandbox')"
								>
									View All
									<img
										src="../../assets/newdesign/assessPro/blueRightArrow.svg"
										alt=""
									/>
								</div>
							</div>

							<div
								class="position-relative mt-16px"
								@mouseenter="hoveredSlider = 'projscrollcontainer'"
								@mouseleave="hoveredSlider = null"
							>
								<!-- LEFT ARROW -->
								<img
									v-show="
										hoveredSlider === 'projscrollcontainer' &&
										scrollStates.projscrollcontainer?.left
									"
									class="position-absolute pointer left-arrow"
									src="../../assets/newdesign/jobsearch/carouselLeft.svg"
									@click="scrollLeft('projscrollcontainer')"
								/>

								<!-- SCROLL -->
								<div
									class="d-flex gap-3 ques-hor-scroll w-100"
									ref="projscrollcontainer"
									@scroll="updateScrollState('projscrollcontainer')"
								>
									<template v-if="loadingProjects">
										<AssessmentCardSkeleton
											v-for="i in 3"
											:key="i"
											:isMobile="!isLaptop"
											customClass="assesspro-cards p-3"
										/>
									</template>

									<template v-else>
										<AssessmentCard
											v-for="(assessment, index) in projectAssessment"
											:key="assessment.assessmentID"
											:isProject="true"
											:assessment="assessment"
											:attemptedTag="true"
											:class="index === 0 ? 'mr-3' : ''"
										/>
									</template>
								</div>

								<!-- RIGHT ARROW -->
								<img
									v-show="
										hoveredSlider === 'projscrollcontainer' &&
										scrollStates.projscrollcontainer?.right
									"
									class="position-absolute pointer right-arrow"
									src="../../assets/newdesign/jobsearch/carouselRight.svg"
									@click="scrollRight('projscrollcontainer')"
								/>
							</div>
							<HorizontalSliderBlog
								v-if="isScrollable('projscrollcontainer')"
								:scrollContainerRef="$refs.projscrollcontainer"
								scrollContainerId="scrollContainer3"
								class="my-3"
							/>
						</section>
						<div
						    v-if="projectAssessment && projectAssessment.length"
							class="view-more-mob-btn fs-13 fw-B fam-mont text-blue d-flex align-items-center justify-content-center"
							id="hideinlaptop"
							@click="goToFilteredAssessment('sandbox')"
						>
							View All<img
								src="../../assets/newdesign/assessPro/blueRightArrow.svg"
								alt=""
							/>
						</div>
						<div
							class="dashed-divider mt-3 mb-0"
							v-if="leaderboardAssessments && leaderboardAssessments.length"
						></div>
						<section
							class="px-3 mt-2"
							v-if="leaderboardAssessments && leaderboardAssessments.length"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<div class="fw-M fs-16 fam-mont text-darkgrey mb-1 mob-fs-14">
										Leaderboard Assessments
									</div>
									<div
										class="fw-LM fs-14 fam-mont text-lightgrey mb-2 mob-fs-12"
									>
										Compete against your peers solving challenges
									</div>
								</div>
								<div
									class="fs-13 fw-M fam-mont text-blue d-flex align-items-center pointer"
									id="hideinmobile"
									@click="goToFilteredAssessment('leaderboard')"
								>
									View All
									<img
										src="../../assets/newdesign/assessPro/blueRightArrow.svg"
										alt=""
									/>
								</div>
							</div>
							<div
								class="position-relative mt-16px"
								:class="{ 'pb-3': !isScrollable('leaderboardscrollcontainer') }"
								@mouseenter="hoveredSlider = 'leaderboardscrollcontainer'"
								@mouseleave="hoveredSlider = null"
							>
								<!-- LEFT ARROW -->
								<img
									v-show="
										hoveredSlider === 'leaderboardscrollcontainer' &&
										scrollStates.leaderboardscrollcontainer?.left
									"
									class="position-absolute pointer left-arrow"
									src="../../assets/newdesign/jobsearch/carouselLeft.svg"
									@click="scrollLeft('leaderboardscrollcontainer')"
								/>

								<!-- SCROLL -->
								<div
									class="d-flex gap-3 ques-hor-scroll w-100"
									ref="leaderboardscrollcontainer"
									@scroll="updateScrollState('leaderboardscrollcontainer')"
								>
									<template v-if="loadingLeaderboard">
										<AssessmentCardSkeleton
											v-for="i in 3"
											:key="i"
											:isMobile="!isLaptop"
											customClass="assesspro-cards p-3"
										/>
									</template>

									<template v-else>
										<AssessmentCard
											v-for="(assessment, index) in leaderboardAssessments"
											:key="assessment.assessmentID"
											:assessment="assessment"
											:attemptedTag="true"
											:class="index === 0 ? 'mr-3' : ''"
											cardType="leaderboard"
										/>
									</template>
								</div>

								<!-- RIGHT ARROW -->
								<img
									v-show="
										hoveredSlider === 'leaderboardscrollcontainer' &&
										scrollStates.leaderboardscrollcontainer?.right
									"
									class="position-absolute pointer right-arrow"
									src="../../assets/newdesign/jobsearch/carouselRight.svg"
									@click="scrollRight('leaderboardscrollcontainer')"
								/>
							</div>
							<HorizontalSliderBlog
								v-if="isScrollable('leaderboardscrollcontainer')"
								:scrollContainerRef="$refs.leaderboardscrollcontainer"
								scrollContainerId="scrollContainer3"
								class="my-3"
							/>
						</section>
						<div
						    v-if="leaderboardAssessments && leaderboardAssessments.length"
							class="view-more-mob-btn fs-13 fw-B fam-mont text-blue d-flex align-items-center justify-content-center"
							id="hideinlaptop"
							@click="goToFilteredAssessment('leaderboard')"
						>
							View All<img
								src="../../assets/newdesign/assessPro/blueRightArrow.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
			</div>
			<!-- <AssessmentSidePanel v-if="isLaptop" /> -->
			<section
				class="lap-asmnt-rightcont mob-w-100 w-25 mob-pb16"
				:class="{
					'lap-asmnt-rightcont-loggedout': !hasAccess(),
					'mob-mt-3': hasAccess(),
				}"
			>
				<div
					v-if="!loadingUserAssessments && !showAsmnttopcard && hasAccess()"
					class="compltd-asmnt-card d-flex align-items-center"
					@click="goToTabAssessment()"
				>
					<img
						src="../../assets/assessment/completedasmnt.svg"
						class=""
						alt=""
					/>
					<div class="mx-2">
						<div class="d-flex align-items-baseline justify-content-between mb-2">
							<div>
								<div class="fw-B fs-14 text-blue fam-mont">
									My Completed Assessments
								</div>
								<div class="fw-R fs-13 text-3A3C40 fam-mont mt-2">
									View reports, Certificates and your assessments
								</div>
							</div>
							<img src="../../assets/assessment/circlearw.svg" alt="" />
						</div>
						<div></div>
					</div>
				</div>
				<RankByCollege
					:class="{
						'mt-3': !loadingUserAssessments && !showAsmnttopcard && hasAccess(),
					}"
					:type="'assessment'"
					:gameType="'technical'"
					class="mb-3"
				/>
				<LeaderBoard
					ref="leaderboard"
					class=""
					:gameType="'technical'"
					:type="$route.query.type || 'assessment'"
				/>
			</section>
		</div>
		<NcdBottomContainer v-if="hasAccess()" />
		<FormModal
			v-if="showForm"
			:showModal="showForm"
			:formType="formType"
			:form="selectedForm"
			:fromJobSearch="true"
			@data-added="refreshCandidateInfo"
			@skip-modal="handleDismissModal"
			@close-modal="showForm = false"
		/>
		<transition name="fade">
			<div
				v-if="!isLaptop && isAnyMobilePopupOpen"
				class="mobile-blur-overlay"
				@click="closeAllPopups"
			></div>
		</transition>
	</div>
</template>

<script>
import HorizontalSliderBlog from "../../components/fixedcomponents/HorizontalScroll.vue";
import RankByCollege from "@/components/Games/RankByCollegeCard.vue";
import LeaderBoard from "@/components/Games/LeaderBoard.vue";
import AssessmentCard from "@/components/Assessment/AssessmentCard.vue";
import AssessmentCategories from "@/components/Assessment/AssessmentCategory.vue";
import AssessmentSidePanel from "@/components/Assessment/AssessmentSidePanel.vue";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import NcdBottomContainer from "@/components/NewCandidateDashboard/NcdBottomContainer.vue";
import { mapGetters } from "vuex";
import {
	getCategories,
	getPublicAssessments,
	getAllAssessments,
	getCandidateOnboard,
} from "@/utils/apiFunctions";
import EventBus from "@/utils/EventBus";
import { hasAccess } from "@/utils/tokenCheck";
import { getCandidateDetail } from "../../controllers/dashboard/asynchronous";
import { getCandidatePrimaryProfile } from "@/utils/apiFunctions";

const CATEGORIES_TAB = "categories";
const SUB_CATEGORIES_TAB = "subcategories";
import AssessmentCardSkeleton from "../../components/Assessment/AssessmentCardSkeleton.vue";
import FormModal from "@/components/BuilderPage/FormModal.vue";

export default {
	name: "AssessmentCategory",
	data() {
		return {
			hoveredSlider: null,
			scrollStates: {},
			current: 0,
			reload: false,
			animateCategory: false,
			categories: null,
			subCategories: {},
			categoryTitle: "",
			subCatHover: null,
			isLaptop: true,
			searchQuery: "",
			tempSearchQuery: "",
			currentTab: CATEGORIES_TAB,
			selectedCategory: null,
			sliding: null,
			completedAssessments: [],
			upcomingAssessments: [],
			ongoingAssessments: [],
			activeAssessmentTab: "completed",
			recommendationAssessments: [],
			projectAssessment: [],
			leaderboardAssessments: [],
			searchQuery: "",
			loadingRecommendations: true,
			loadingProjects: true,
			loadingLeaderboard: true,
			loadingUserAssessments: true,
			loadingCategories: false,
			showForm: false,
			selectedForm: null,
			formType: "add",
			formCheckTimeout: null,
			showMoreMenu: false,
		};
	},
	components: {
		NcdBottomContainer,
		AssessmentSidePanel,
		NcdTopContainer,
		AssessmentCard,
		AssessmentCategories,
		HorizontalSliderBlog,
		RankByCollege,
		LeaderBoard,
		AssessmentCardSkeleton,
		FormModal,
	},
	async created() {
		EventBus.$on("message-sent", (message) => {
			this.selectCategory(null);
			this.currentTab = CATEGORIES_TAB;
		});
		EventBus.$on("login-success", this.onLoginSuccess);
		EventBus.$on("onboarding-fetch-post-login", this.onLoginSuccess);
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
		this.createdActions();

		this.selectedCategory = this.$route.query.category;
		this.categoryTitle = this.$route.query.categoryTitle;

		if (this.selectedCategory) {
			this.currentTab = SUB_CATEGORIES_TAB;
		}
		const { tab } = this.$route.query;

		if (tab) {
			this.activeAssessmentTab = tab;
		}
		this.getAllAssessments();
		this.getRecommendationAssessments();
		this.getCategoriesAndSubCategories();
		this.getProjects();
		this.getLeaderBoard();
		if (this.hasAccess()) {
			this.refreshCandidateInfo();
		}
	},
	mounted() {
		this.mountedActions();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	beforeDestroy() {
		if (this.formCheckTimeout) clearTimeout(this.formCheckTimeout);
		EventBus.$off("login-success", this.onLoginSuccess);
		EventBus.$off("onboarding-fetch-post-login", this.onLoginSuccess);
	},
	methods: {
		closeAllPopups() {
			this.showMoreMenu = false;
		},
		hasAccess() {
			return hasAccess();
		},
		onLoginSuccess() {
			this.createdActions();
			this.mountedActions();
		},
		createdActions() {
			this.selectedCategory = this.$route.query.category;
			this.categoryTitle = this.$route.query.categoryTitle;

			if (this.selectedCategory) {
				this.currentTab = SUB_CATEGORIES_TAB;
			}
			const { tab } = this.$route.query;

			if (tab) {
				this.activeAssessmentTab = tab;
			}
			this.getPublicAssessments();
			this.getCategoriesAndSubCategories();
			this.getAllAssessments();
			this.getRecommendationAssessments();
			this.getProjects();
			this.getLeaderBoard();
		},
		mountedActions() {
			this.$nextTick(() => {
				[
					"completedasmntscroll",
					"upcomingasmntscroll",
					"recomendationscroll",
					"projscrollcontainer",
					"leaderboardscrollcontainer",
				].forEach((ref) => {
					this.updateScrollState(ref);
				});
			});

			if (this.hasAccess()) {
				this.formCheckTimeout = setTimeout(() => {
					this.checkAndOpenFormModal();
				}, 10000);
			}
		},
		async checkAndOpenFormModal() {
			// if (!this.primaryCandidateInfo) return;
			try {
				const onboardRes = await getCandidateOnboard();
				const onboardData = onboardRes?.data?.data;
				if (onboardData?.onboardingCompleted === false) {
					return;
				}
			} catch (err) {
				console.error("[LaptopJobSearch] getCandidateOnboard error:", err);
			}

			// Check if modal was dismissed in the last hour
			const lastDismissed = localStorage.getItem("lastDismissedProfileModal");
			const oneHour = 60 * 60 * 1000;
			if (lastDismissed && Date.now() - parseInt(lastDismissed) < oneHour) {
				return;
			}

			const info = this.primaryCandidateInfo;
			if (!info.database_demographics) return;
			const expLevel = info.experienceLevel;

			if (
				expLevel === "fresher" &&
				(!info.educationalInfo || info.educationalInfo.length === 0)
			) {
				this.selectedForm = {
					formID: "education",
					formName: "Educational Info",
					selectedTabOnCrud: "education",
				};
				this.formType = "add";
				this.showForm = true;
			} else if (
				expLevel &&
				expLevel !== "fresher" &&
				(!info.experience || info.experience.length === 0)
			) {
				this.selectedForm = {
					formID: "experience",
					formName: "Experience Info",
					selectedTabOnCrud: "experience",
				};
				this.formType = "add";
				this.showForm = true;
			}
		},
		handleDismissModal() {
			this.showForm = false;
			localStorage.setItem("lastDismissedProfileModal", Date.now().toString());
		},
		async refreshCandidateInfo() {
			try {
				// Use no-id endpoint to always fetch the primary profile, not a stale per-profile id from the store.
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200 && res.data.data) {
					this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
				}
			} catch (error) {
				console.error("Error refreshing candidate info:", error);
			}
		},
		goToallAssessmentProgress() {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: {
					from: "viewAllassessments",
				},
			});
		},
		goToTabAssessment() {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: {
					tab: this.activeAssessmentTab,
				},
			});
		},
		updateScrollState(refName) {
			const container = this.$refs[refName];
			if (!container) return;

			const el = Array.isArray(container) ? container[0] : container;

			const scrollLeft = el.scrollLeft;
			const maxScrollLeft = el.scrollWidth - el.clientWidth;

			this.$set(this.scrollStates, refName, {
				left: scrollLeft > 5,
				right: scrollLeft < maxScrollLeft - 5,
			});
		},
		scrollLeft(refName) {
			const el = this.$refs[refName];
			const container = Array.isArray(el) ? el[0] : el;

			const card = container.children[0]; // 🔥 first child directly

			if (card) {
				const cardWidth = card.offsetWidth + 16;

				container.scrollBy({
					left: -cardWidth,
					behavior: "smooth",
				});

				setTimeout(() => this.updateScrollState(refName), 300);
			}
		},

		scrollRight(refName) {
			const el = this.$refs[refName];
			const container = Array.isArray(el) ? el[0] : el;

			const card = container.children[0]; // 🔥 FIX

			if (card) {
				const cardWidth = card.offsetWidth + 16;

				container.scrollBy({
					left: cardWidth,
					behavior: "smooth",
				});

				setTimeout(() => this.updateScrollState(refName), 300);
			}
		},
		isScrollable(refName) {
			const el = this.$refs[refName];

			if (!el) {
				console.warn(`Ref ${refName} not found`);
				return false;
			}

			const element = Array.isArray(el) ? el[0] : el;

			return element.scrollWidth > element.clientWidth;
		},
		handleSearch() {
			if (!this.tempSearchQuery || !this.tempSearchQuery.trim()) return;

			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: {
					searchQuery: this.tempSearchQuery,
				},
			});
		},
		async getAllAssessments() {
			this.loadingUserAssessments = true;
			try {
				const payload = {
					email: this.userInfo.email,
				};
				const res = await getAllAssessments(payload);

				if (res.status === 200) {
					this.loadingUserAssessments = false;
					this.completedAssessments = res.data.data.completed;
					this.upcomingAssessments = res.data.data.upcoming;
					this.ongoingAssessments = res.data.data.ongoing;

					if (this.isLaptop && !this.$route.query.tab) {
						if (this.completedAssessments.length) {
							this.activeAssessmentTab = "completed";
						} else if (this.upcomingAssessments.length) {
							this.activeAssessmentTab = "upcoming";
						} else if (this.ongoingAssessments.length) {
							this.activeAssessmentTab = "ongoing";
						}
					}
				} else {
					throw new Error("Failed with status: " + res.status);
				}
			} catch (err) {
				this.loadingUserAssessments = false;
				console.error(err);
				this.completedAssessments = [];
				this.upcomingAssessments = [];
				this.ongoingAssessments = [];
			} finally {
				this.loadingUserAssessments = false;
			}
		},
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		async getPublicAssessments() {
			try {
				const response = await getPublicAssessments({
					email: this.userEmail,
					count: 10,
					home: true,
					searchQuery: this.searchQuery || "",
				});
				if (response.status == 200) {
					this.publicAssessment = response.data.data.data;
					console.log("this.public", this.publicAssessment);
				}
			} catch (error) {
				return error;
			}
		},
		async getRecommendationAssessments() {
			this.loadingRecommendations = true;

			try {
				// FIRST CALL (recommend = true)

				let response = await getPublicAssessments({
					email: this.userInfo.email,
					count: 10,
					home: true,
					recommend: true,
					filter: { assessmentType: ["assessments"] },
				});

				if (response.status === 200) {
					let data = response.data.data.data || [];

					// IF EMPTY → CALL AGAIN WITHOUT recommend
					if (!data.length) {
						let fallbackRes = await getPublicAssessments({
							email: this.userInfo.email,
							count: 10,
							home: true,
						});

						if (fallbackRes.status === 200) {
							this.recommendationAssessments = fallbackRes.data.data.data || [];
						}
					} else {
						this.recommendationAssessments = data;
						this.loadingRecommendations = false;
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getProjects() {
			this.loadingProjects = true;
			try {
				const response = await getPublicAssessments({
					email: this.userInfo.email,
					count: 10,
					home: true,
					filter: { assessmentType: ["sandbox"] },
				});

				if (response.status == 200) {
					this.loadingProjects = false;
					this.projectAssessment = response.data.data.data;
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getLeaderBoard() {
			this.loadingLeaderboard = true;
			try {
				const response = await getPublicAssessments({
					email: this.userInfo.email,
					count: 10,
					home: true,
					filter: { assessmentType: ["leaderboard"] },
				});

				if (response.status == 200) {
					this.loadingLeaderboard = false;
					this.leaderboardAssessments = response.data.data.data;
				}
			} catch (error) {
				console.error(error);
			}
		},
		goToFilteredAssessment(type) {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: {
					practice: type,
				},
			});
		},
		handleCategorySelect(category) {
			this.$router.push({
				name: "CandidateAssessmentProgress",
				query: {
					categoryIDs: JSON.stringify([category.categoryID]),
				},
			});
		},
		async getCategoriesAndSubCategories() {
			this.searchQuery = this.tempSearchQuery;
			await this.getCategories();
		},
		async getCategories() {
			this.loadingCategories = true;
			this.searchQuery = this.tempSearchQuery;
			this.categories = null;
			try {
				const res = await getCategories({ searchQuery: this.searchQuery });
				if (res.status === 200) {
					this.categories = res.data.data;
					this.loadingCategories = false;
					if (this.categories.length === 0) {
						this.subCategories = {};
					}
				}
			} catch (error) {
				console.log(error);
				this.categories = [];
			}
		},

		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		handleBackClick() {
			if (this.showCategories) {
				// If we're on categories view, go back to previous page
				this.$router.go(-1);
			} else {
				// If we're on sub-categories view, go back to categories view
				this.goBackToCategories();
			}
		},
		handleMobileBackClick() {
			if (this.$route.query.from === "home") {
				// If we came from home, go back to previous page
				this.$router.go(-1);
			} else {
				// Otherwise, go back to categories view
				this.goBackToCategories();
			}
		},
		goBackToCategories() {
			// Set tab first to prevent route updates
			this.currentTab = CATEGORIES_TAB;
			// Clear category selection and update route to remove query params
			this.selectedCategory = null;
			this.categoryTitle = "";
			this.$router.replace({
				name: "AssessmentCategory",
				query: {},
			});
		},
		selectCategory(categoryID, categoryTitle) {
			this.categoryTitle = categoryTitle;
			this.selectedCategory = categoryID;
		},
		gotoSubCategory(categoryID, categoryTitle) {
			this.reload = true;
			this.animateCategory = true;
			// Set currentTab first to ensure watcher uses replace() instead of push()
			this.currentTab = SUB_CATEGORIES_TAB;
			this.selectedCategory = categoryID;
			this.categoryTitle = categoryTitle;
			this.getSubCategories(categoryID);
			setTimeout(() => {
				this.animateCategory = false;
			}, 400);
		},
		goToAssessmentProgress() {
			console.log("the category title is", this.categoryTitle);
			this.$router.push({
				name: "CandidateAssessmentProgress",
				// query: {
				// 	subCategoryTitle,
				// 	subCategory: subCategoryID,
				// 	category: categoryID || this.$route.query.category,
				// 	categoryTitle: this.categoryTitle,
				// 	searchQuery: this.searchQuery,
				// },
			});
		},
		getCategoryStats(category) {
			return this.subCategories[category.categoryID]
				? `${this.subCategories[category.categoryID].length} Sub-${
						this.subCategories[category.categoryID].length == 1
							? "category"
							: "categories"
				  } | ${category.testCount} ${
						category.testCount == 1 ? "Test" : "Tests"
				  }`
				: "- Sub-Categories | - Tests";
		},
		getSubCategoryStats(subCategory) {
			return `${subCategory.testCount} ${
				subCategory.testCount == 1 ? "Test" : "Tests"
			}`;
		},
	},
	computed: {
		isPageLoading() {
			return (
				this.loadingUserAssessments ||
				this.loadingRecommendations ||
				this.loadingProjects ||
				this.loadingLeaderboard ||
				this.loadingCategories
			);
		},
		showAsmnttopcard() {
			if (
				this.hasAccess() &&
				(this.completedAssessments.length ||
					this.upcomingAssessments.length ||
					this.ongoingAssessments.length ||
					this.completedAssessments.completedAssessmentRecently)
			)
				return true;
			else return false;
		},
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			primaryCandidateInfo: "getPrimaryCandidateInfo",
		}),
		showCategories() {
			// Only update route if we have a selectedCategory and we're on categories tab
			// Don't update if selectedCategory is null (going back)
			if (this.currentTab == CATEGORIES_TAB && this.selectedCategory) {
				this.$router.replace({
					name: "AssessmentCategory",
					query: {
						category: this.selectedCategory,
						categoryTitle: this.categoryTitle,
					},
				});
			}
			return this.currentTab === CATEGORIES_TAB;
		},
		showSubCategories() {
			return this.currentTab === SUB_CATEGORIES_TAB;
		},
		CATEGORIES_TAB() {
			return CATEGORIES_TAB;
		},
		SUB_CATEGORIES_TAB() {
			return SUB_CATEGORIES_TAB;
		},
		isAnyMobilePopupOpen() {
			return this.showMoreMenu;
		},
	},
	watch: {
		recommendationAssessments() {
			this.$nextTick(() => {
				this.updateScrollState("recomendationscroll");
			});
		},
		projectAssessment() {
			this.$nextTick(() => {
				this.updateScrollState("projscrollcontainer");
			});
		},
		leaderboardAssessments() {
			this.$nextTick(() => {
				this.updateScrollState("leaderboardscrollcontainer");
			});
		},
		completedAssessments() {
			this.$nextTick(() => {
				this.updateScrollState("completedasmntscroll");
			});
		},
		upcomingAssessments() {
			this.$nextTick(() => {
				this.updateScrollState("upcomingasmntscroll");
			});
		},
		activeAssessmentTab() {
			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		tempSearchQuery() {
			if (this.tempSearchQuery === this.searchQuery) return;
			if (this.tempSearchQuery) return;

			if (this.showCategories) this.getCategories();
			else this.getCategoriesAndSubCategories();
		},
		selectedCategory(newV) {
			// Don't update route if selectedCategory is null (handled in goBackToCategories)
			if (!newV) return;

			if (this.currentTab === CATEGORIES_TAB && newV) {
				this.$router.push({
					name: "AssessmentCategory",
					query: {
						category: this.selectedCategory,
						categoryTitle: this.categoryTitle,
						from: this.$route.query.from,
						type: this.$route.query.type,
					},
				});
			} else if (this.currentTab === SUB_CATEGORIES_TAB) {
				this.current = 0;
				this.$router.replace({
					name: "AssessmentCategory",
					query: {
						category: this.selectedCategory,
						categoryTitle: this.categoryTitle,
						from: this.$route.query.from,
						type: this.$route.query.type,
					},
				});
			}
		},
		currentTab() {
			if (this.currentTab === SUB_CATEGORIES_TAB) {
				setTimeout(() => {
					this.current = 1;
				}, 1000);
			}
		},
		$route() {
			if (this.currentTab === SUB_CATEGORIES_TAB && this.current == 1) {
				this.currentTab = CATEGORIES_TAB;
			}
		},
	},
};
</script>

<style>
.dashed-divider {
	width: 100%;
	height: 1px;
	background-image: repeating-linear-gradient(
		to right,
		#d1d5db 0px,
		#d1d5db 8px,
		transparent 8px,
		transparent 16px
	);
}

.cat-overflow {
	height: calc(100vh - 204px);
	overflow: auto;
	padding: 13px 6px 13px 13px;
}

.cat-cards {
	box-shadow: 0px 4px 9px 0px #00000026;
	border: 1px solid #8c8c8c54;
	background: #fcfcfc;
	width: 265px;
	height: 275px;
	border-radius: 8px;
	padding: 10px;
	position: relative;
}

.cat-badge-top {
	position: absolute;
	background: linear-gradient(
		85.18deg,
		rgba(32, 99, 155, 0.8) 0.71%,
		rgba(32, 99, 155, 0.08) 184.92%
	);
	backdrop-filter: blur(3.824277400970459px);
	padding: 1px 12px;
	border-radius: 7px 0px 8px 0px;
	left: 0px;
	top: 0px;
}

.subcat-badge-top {
	background: linear-gradient(
		85.18deg,
		rgba(32, 99, 155, 0.8) 0.71%,
		rgba(32, 99, 155, 0.08) 184.92%
	);
	backdrop-filter: blur(3.824277400970459px);
	padding: 1px 12px;
	border-radius: 8px;
	text-align: center;
	min-width: 64px;
}

.cat-img {
	width: 100%;
	height: 155px;
	border-radius: 8px;
	overflow: hidden;
}

.cat-cards:hover {
	background: linear-gradient(98.4deg, #dfdfff 18.14%, #ffffff 114.96%);
}

.cat-blue-txt {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-15);
	font-weight: var(--weight-M);
	color: var(--bg-proTheme);
}

.cat-grey-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-style: italic;
	font-weight: 500;
	color: #797b81;
}

.cat-grey-txt {
	word-break: break-word;
	word-wrap: break-word;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	@supports (-webkit-line-clamp: 2) {
		display: -webkit-box !important;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		-webkit-line-clamp: 3;
	}
}

.cat-heading {
	font-family: "Lato", sans-serif;
	font-size: var(--size-16);
	font-weight: var(--weight-LM);
	color: #333333;
}

.subcat-overflow {
	height: calc(100vh - 204px);
	display: flex;
}

.subcat-left-overflow {
	height: 100%;
	overflow: auto;
	padding: 10px;
	width: 32%;
	border-right: 1px solid #dddddd;
}

.subcat-right-overflow {
	height: 100%;
	overflow: auto;
	padding: 10px;
	width: 68%;
	display: flex;
	flex-direction: column;
}

.subcat-left-selected-card {
	background-color: #20639b;
	border: 1px solid #20639b;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 6px;
	padding: 10px 15px;
	font-family: "Montserrat", sans-serif;
	font-size: 15px;
	font-weight: 600;
	color: #ffffff;
	box-shadow: 0px 4px 8px 0px #00000014;
}

.subcat-left-unselected-card {
	background-color: #fcfcfc;
	border: 1px solid #d7d7d7;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 6px;
	padding: 10px 15px;
	font-family: "Montserrat", sans-serif;
	font-size: 15px;
	font-weight: 600;
	color: #20639b;
	box-shadow: 0px 4px 8px 0px #00000014;
}

.subcat-num-white {
	height: 30px;
	width: 30px;
	border-radius: 50%;
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--bg-proTheme);
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}

.subcat-num-blue {
	height: 30px;
	width: 30px;
	border-radius: 50%;
	font-family: "Lato", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--bg-proTheme);
	background-color: #f6f9fb;
	display: flex;
	align-items: center;
	justify-content: center;
}

.subcat-right-card {
	background: #ffffff;
	box-shadow: 0px 1px 8px 0px #0000002b;
	border: 1px solid white;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 20px;
	position: relative;
}

.subcat-right-card:hover {
	background: linear-gradient(76.52deg, #dfdfff -36.8%, #ffffff 106.74%);
	border: 1px solid #8c8c8c54;
}

.subcat-blue-line {
	background-color: #20639b;
	border-radius: 5px;
	height: 90%;
	left: 5px;
	width: 4px;
	position: absolute;
}

.subcat-greytxt {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-style: italic;
	font-weight: 500;
	color: #70737b;
}

.subcat-bluetxt {
	font-family: "Lato", sans-serif;
	font-size: 15px;
	font-weight: 400;
	color: #20639b;
}
.ques-hor-scroll::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.ques-hor-scroll {
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
}
@media only screen and (max-width: 1028px) {
	.subcat-right-overflow {
		height: calc(100dvh - 145px) !important;
		overflow: auto;
		padding: unset !important;
		width: 100% !important;
		display: flex;
		flex-direction: column;
		margin-top: 12px;
	}
	.mob-ml-2 {
		margin-left: 5px;
	}
	.cat-overflow {
		padding: 0px !important;
		margin-top: 5px;
		height: calc(100dvh - (200px + env(safe-area-inset-top)));
	}
	.cat-cards {
		box-shadow: 0px 4px 9px 0px #00000026;
		border: 1px solid #8c8c8c54;
		background: #fcfcfc;
		width: 100% !important;
		height: unset !important;
		border-radius: 8px;
		padding: 10px;
	}
	.fading-card-flex {
		gap: 15px;
	}
	/* new design */
	.viewall-asmnt-card {
		width: 100%;
		padding: 10px 16px;
		border-radius: 0px 0px 8px 8px;
		background: #304254;
	}
	.asmnt-mobile-whitecards {
		background: #ffffff;
		border-radius: 8px;
	}
	.mob-padding-12 {
		padding: 12px;
	}
	.asmnt-top-search-cards {
		background: #f7f9fb;
	}
	.asmnt-body-mainheight {
		height: calc(100dvh - 100px);
	}
	.mob-align-items-center {
		align-items: center;
	}
	.mob-overflowx-auto {
		overflow-x: auto;
	}
	.mob-w-100 {
		width: 100% !important;
	}
	.js-carousel-parent {
		height: 210px;
	}
	.js-carousel-parent .carousel {
		height: 67%;
	}
	.mob-px-0 {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
	.view-more-mob-btn {
		background: rgba(32, 99, 155, 0.05);
		padding: 10px;
	}
	.mob-mt-3 {
		margin-top: 1rem;
	}
	.nodata-hw {
		height: 100px;
		width: 100px;
	}
	.mob-content-between {
		justify-content: space-between !important;
	}
	.category-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
		gap: 12px;
	}
	.mob-pb16 {
		padding-bottom: 16px !important;
		margin-bottom: 35px !important;
	}
}
@media only screen and (min-width: 1029px) {
	.lap-asmnt-rightcont {
		width: 30%;
		height: calc(100vh - 148px);
		overflow: auto;
	}
	.lap-asmnt-rightcont-loggedout {
		width: 30%;
		height: calc(100vh - 115px);
		overflow: auto;
	}
	.fading-class {
		opacity: 1;
	}

	.fading-reverse-class {
		opacity: 0.1;
		animation: fadeIn 0.6s ease-in-out forwards;
		animation-delay: 0.1s; /* Optional delay before the transition starts */
	}
	@keyframes fadeIn {
		from {
			opacity: 0.1;
		}
		to {
			opacity: 1;
		}
	}
	.fading-card-flex {
		transition: all 0.6s ease-in-out; /* Smooth transition for flex properties */
		gap: 15px;
	}

	.fading-class .fading-card-flex {
		/* transition: all 0.3s linear; */
		flex-direction: column;
		gap: 0.5rem;
	}
	.fading-card-flex .cat-cards {
		transition: opacity 0.35s ease;
		opacity: 1;
	}

	.fading-class .fading-card-flex .cat-cards {
		height: 51px;
		overflow: hidden;
		flex-shrink: 0;
		opacity: 0;
	}
	.fading-class .cat-img {
		display: none;
	}
	.fading-class .fading-mt {
		margin-top: 0 !important;
	}
	.fading-class .fading-mb {
		margin-bottom: 50px !important;
		margin-top: 7px;
	}
}

.your-asmnt-container {
	background: #ffffff;
	border-radius: 8px;
}
.compltd-asmnt-card {
	width: 100%;
	background: #e8f5ff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	overflow: hidden;
}
.asmnt-top-search-cards {
	background-color: #f7f9fb;
	overflow: hidden;
	border-radius: 8px;
}
.asp-sel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #20639b;
	padding: 12px 14px;
	position: relative;
	cursor: pointer;
}

.asp-unsel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #000000;
	padding: 12px 14px;
	cursor: pointer;
}

.asp-sel-line {
	position: absolute;
	height: 4px;
	width: 100%;
	border-radius: 12px;
	background-color: #20639b;
	bottom: 0px;
	left: 0px;
}
.outerscroll-asmntcard {
	height: calc(100vh - 148px);
	overflow: auto;
}
.left-arrow {
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	z-index: 2;
}

.right-arrow {
	top: 50%;
	right: 0;
	transform: translateY(-50%);
	z-index: 2;
}
.mt-20px {
	margin-top: 20px;
}
.mt-16px {
	margin-top: 16px;
}
.mb-16px {
	margin-bottom: 16px;
}
.pb-16px {
	padding-bottom: 16px;
}
.pb-1px {
	padding-bottom: 1px;
}
.pr-16px {
	padding-right: 16px;
}
.category-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(168px, max-content));
	gap: 12px;
	justify-content: start;
}
.left-arrow,
.right-arrow {
	filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.25));
}
.outerscroll-asmntcard-loggedout {
	height: calc(100vh - 115px);
}
.cand-dashboard-maincontainer-loggedout {
	height: calc(100vh - 72px);
	top: 72px;
	padding: 15px;
}
@media only screen and (max-width: 1028px) {
	.assesspro-cards {
		width: 100% !important;
	}
	.outerscroll-asmntcard {
		height: unset;
	}
	.mobw-70 {
		width: 70%;
	}
	.outerscroll-asmntcard-loggedout {
		height: unset !important;
	}
	.top80px {
		top: 80px !important;
	}
}
.h-maxcontent {
	height: max-content;
}
</style>
